import Vue from "vue";
import Router from "vue-router";
import routes from "./router";

Vue.use(Router);

const originalPush = Router.prototype.push;

// 路由故障
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

// scroll行为
const scrollBehavior = (to, from, savedPosition) => {
  if (to.hash) {
    // https://stackoverflow.com/questions/40341939/how-to-create-anchor-tags-with-vue-router
    // setTimeout(() => {
    //   // 延迟手动触发动画
    //   const element = document.getElementById(to.hash.replace(/#/, ""));
    //   element &&
    //     element.scrollIntoView &&
    //     element.scrollIntoView({ block: "start", behavior: "smooth" });
    //
    //   return { selector: to.hash };
    // }, 0);
    return { selector: to.hash, behavior: "smooth" };
  } else {
    return {
      x: 0,
      y: 0,
      behavior: "smooth"
    };
  }
};

const router = new Router({
  //export default new Router({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior
});

export default router;
